import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'ui-components/Card'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { StyledNumber } from 'ui-components/StyledNumber'
import { CardTitle } from 'ui-components/CardTitle'

export default function StockInfo({ product }) {
  const {
    product_stock_attributes: stock,
    unit_type: unitType,
    unit_quantity: unitQuantity,
  } = product.attributes

  return (
    <Card>
      <CardTitle title="ESTOQUE" noMargin />
      <DescItemInfo label="Qtd. disponível">
        <StyledNumber number={stock.available} />
      </DescItemInfo>

      <DescItemInfo label="Qtd. estoque">
        <StyledNumber number={stock.quantity} />
      </DescItemInfo>

      <DescItemInfo label="Qtd. reservada">
        <StyledNumber number={stock.reserved} />
      </DescItemInfo>

      <DescItemInfo label="Qtd. mínima">
        {stock.minimum_quantity}
      </DescItemInfo>

      <CardTitle title="MEDIDAS" />
      <DescItemInfo label="Medida da unidade">
        {unitType}
      </DescItemInfo>

      <DescItemInfo label="Qtd. por embalagem">
        {unitQuantity}
      </DescItemInfo>
    </Card>
  )
}

StockInfo.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
}
